import * as React from 'react';

import { usePreferences } from './preferences';

// A horizontal bar under the line being read. It follows the pointer, and keyboard focus, so
// it also helps visitors who tab through the page.
export default function ReadingGuide() {
  const { readingGuide } = usePreferences();
  const [top, setTop] = React.useState<number | null>(null);

  React.useEffect(() => {
    if (!readingGuide) {
      setTop(null);
      return;
    }
    let frame = 0;
    const moveTo = (y: number) => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => setTop(y));
    };
    const onPointer = (event: PointerEvent) => moveTo(event.clientY + 12);
    const onFocus = (event: FocusEvent) => {
      if (!(event.target instanceof Element)) return;
      moveTo(event.target.getBoundingClientRect().bottom + 4);
    };
    window.addEventListener('pointermove', onPointer, { passive: true });
    document.addEventListener('focusin', onFocus);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('pointermove', onPointer);
      document.removeEventListener('focusin', onFocus);
    };
  }, [readingGuide]);

  if (!readingGuide || top === null) return null;
  return (
    <div
      className='site-reading-guide-bar'
      aria-hidden='true'
      data-testid='reading-guide'
      style={{ transform: `translateY(${Math.round(top)}px)` }}
    />
  );
}
